<template>
  <div class="iframe-container">
    <!-- <pipedrive-frame :token="token || ''"></pipedrive-frame> -->
    <StatusPanel :token="token || ''"></StatusPanel>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
//import PipedriveFrame from '../components/PipedriveFrame.vue'
import StatusPanel from './StatusPanel.vue';

export default {
  name: 'IframeView',
  components: {
    //PipedriveFrame,
    StatusPanel
  },
  setup() {
    const token = ref(null)

    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search)
      const tokenFromUrl = urlParams.get('token')
      if (tokenFromUrl) {
        token.value = tokenFromUrl
      } else {
        const clientId = process.env.VUE_APP_PIPEDRIVE_CLIENT_ID
        const redirectUri = process.env.VUE_APP_REDIRECT_URI
        const scope = 'contacts:read deals:read'
        const authUrl = `https://oauth.pipedrive.com/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`
        window.location.href = authUrl
      }
    })

    return {
      token
    }
  },
  metaInfo() {
    return {
      script: [
        {
          src: 'https://cdn.jsdelivr.net/npm/@pipedrive/app-extensions-sdk@0/dist/index.umd.js',
          defer: true
        }
      ]
    }
  }
}
</script>

<style scoped>
.iframe-container {
  width: 100%;
  height: 100vh;
  padding: 0;
  margin: 0;
}
</style>
